var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.priority)+" "),_c('font-awesome-icon',{staticClass:"ml-2",class:_vm.getIconClass(_vm.row.priority),attrs:{"icon":['fal', _vm.getIcon(_vm.row.priority)]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }